import { render, staticRenderFns } from "./HolidaySettingsView.vue?vue&type=template&id=b065533c&"
import script from "./HolidaySettingsView.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VCheckbox,VDatePicker})
